import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDate(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}

export function formatFileSize(bytes) {
  if (bytes === null || bytes === undefined || isNaN(bytes)) return '—';
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}


export function getStatusLabel(status) {
  const labels = {
    pending: 'Not Started',
    requested: 'SAR Sent',
    received: 'Data Received',
    uploaded: 'Documents Uploaded',
  };
  return labels[status] || status;
}

export function getOrgTypeLabel(type) {
  if (!type) return '';
  const labels = {
    council: 'Local Council',
    local_council: 'Local Council',
    local_authority: 'Local Authority',
    fostering_agency: 'Fostering Agency',
    foster_care: 'Foster Care',
    childrens_home: "Children's Home",
    adoption: 'Adoption Agency',
    school: 'School',
    doctor: 'GP Surgery',
    gp: 'GP Surgery',
    hospital: 'Hospital',
    healthcare: 'Healthcare Provider',
    police: 'Police',
    mental_health: 'Mental Health Service',
  };
  if (labels[type]) return labels[type];
  // Humanise any unknown snake_case enum: "youth_justice" → "Youth Justice"
  return String(type)
    .split(/[_\s]+/)
    .filter(Boolean)
    .map(w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(' ');
}

export function getOrgTypeIcon(type) {
  const icons = {
    council: 'Building2',
    fostering_agency: 'Heart',
    childrens_home: 'Building',
    adoption: 'Heart',
    school: 'GraduationCap',
    doctor: 'Stethoscope',
    hospital: 'Hospital',
    police: 'Shield',
    mental_health: 'Brain',
  };
  return icons[type] || 'FileText';
}
